import React from "react";
import { Modal } from "react-bootstrap";
import { Card, Row, Col, Button, Form, Alert, Table } from "react-bootstrap";
export default function ModalPengumuman(props) {
  const { show, data, handleClose } = props;
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Pengumuman</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: data?.isi }} />

        <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                    <Button
                      block
                      variant="primary"
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      <strong>T U T U P</strong>
                    </Button>
                  </div>
      </Modal.Body>
    </Modal>
  );
}
